import { render, staticRenderFns } from "./received-order-list.vue?vue&type=template&id=ac01451c&scoped=true&"
import script from "./received-order-list.vue?vue&type=script&lang=js&"
export * from "./received-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac01451c",
  null
  
)

export default component.exports